import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'
// import * as Cookies from 'js-cookie'
// persistedState 状态持久化工具
// vuex是在中大型项目中必不可少的状态管理组件，刷新会重新更新状态，但是有时候我们并不希望如此。例如全局相关的，如登录状态、token、以及一些不常更新的状态等，我们更希望能够固化到本地，减少无用的接口访问，以及更佳的用户体验。
// 默认使用 localStorage 存储
// 切换 sessionStorage 存储 => persistedState({ storage: window.sessionStorage })
// 切换 cookie 存储 需要引入 js-cookie => https://github.com/js-cookie/js-cookie
// persistedState({
//   storage: {
//     getItem: key => Cookies.get(key),
//     setItem: (key, value) => Cookies.set(key, value, { expires: 7 }),
//     removeItem: key => Cookies.remove(key)
//   }
// })
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [persistedState()],
  modules: {
    user
  },
  getters
})

export default store
